// accountBalancesTable.js - Enhances the account balances table with status and comments.
if (typeof window.Lux_auditObserver === 'undefined') {
  window.Lux_auditObserver = null
}

function Lux_Table_initializeAuditModeButton() {
  const anchorSelector = '.header-component'
  const buttonId = 'lux-audit-mode-btn'

  console.log('Initializing Audit Mode Button...')

  const anchorElement = document.querySelector(anchorSelector)
  if (!anchorElement) {
    console.log('Lux Inject: Anchor for audit button not found. Retrying...')
    return false
  }

  if (document.getElementById(buttonId)) {
    console.log('Lux Inject: Audit button already initialized.')
    return true
  }

  console.log('Lux Inject: Initializing audit button...')
  const auditButton = document.createElement('button')
  auditButton.type = 'button'
  auditButton.classList = 'ant-btn ant-btn-text Button'

  auditButton.id = buttonId
  auditButton.textContent = 'Belegprüfung aktivieren' // Initial loading text

  // Insert the button into the DOM synchronously BEFORE async operations
  anchorElement.insertBefore(auditButton, anchorElement.childNodes[0])
  console.log(
    'Lux Inject: Audit button element injected, now fetching status...'
  )
  auditButton.addEventListener('click', async () => {
    window.Lux_auditObserver = true;
    auditButton.disabled = true
    auditButton.textContent = 'Belegprüfung aktiviert'
    window.auditMode = true
    const overlayWrappers = document.querySelectorAll('div.overlay-wrapper')
    if (overlayWrappers.length < 2) return // Need the second wrapper

    const tableContainer = overlayWrappers[1].querySelector(
      '.ant-table-container'
    )
    if (!tableContainer) return

    const tableBody = tableContainer.querySelector('tbody.ant-table-tbody')
    const dataRows = tableBody
      ? Array.from(
          tableBody.querySelectorAll('tr.ant-table-row:not(.lux-row-enhanced)')
        )
      : []

    prepareTable(tableContainer, 'administrator')
    const tableObserver = new MutationObserver(Lux_Table_newRowsAdded)
    tableObserver.observe(tableBody, {
      childList: true,
    })
    enhanceNewRows(dataRows)
    Lux_Table_updateAllStatusIcons()
  })
}
